import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaPencil } from "react-icons/fa6";
import ApiService from "../../services/ApiService";

function ProfileEditor({ editable, setEditable }) {
  // const [editable, setEditable] = useState(edit);

  const [loader, setLoader] = useState(false);
  const [languages, setLanguages] = useState();
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  let errorsObj = {};
  const [errors, setErrors] = useState(errorsObj);
  const [states, setStates] = useState();

  const [formData, setFormData] = useState({
    username: "",
    salutation: "",
    firstName: "",
    middleName: "",
    lastName: "",
    fatherName: "",
    grade: "",
    board: "",
    state: "",
    mobile: "",
    alternateMobile: "",
    dateOfBirth: "",
    school: "",
    address: "",
    city: "",
    twitter: "",
    facebook: "",
    linkedin: "",
  });

  useEffect(() => {
    const userDetailss = localStorage.getItem("userDetails");
    const userData = JSON.parse(userDetailss);

    setFormData({
      username: userData.username,
      email: userData.email,
      salutation: userData.salutation || "",
      firstName: userData.firstName || "",
      middleName: userData.middleName || "",
      lastName: userData.lastName || "",
      fatherName: userData.fatherName || "",
      grade: userData.grade || "",
      board: userData.category || "",
      mobile: userData.mobile || "",
      alternateMobile: userData.alternateMobile || "",
      dateOfBirth: userData.dob || "",
      school: userData.school || "",
      address: userData.address || "",
      city: userData.city || "",
      state: userData.state || "",
      twitter: userData.twitter || "",
      facebook: userData.facebook || "",
      linkedin: userData.linkedin || "",
    });

    console.log("User details from profile editor", userData);
  }, []);

  // const handleInputChange = (event) => {
  //   setFormData({
  //     ...formData,
  //     [event.target.name]: event.target.value,
  //   });
  // };

  const updateUser = (e) => {
    e.preventDefault();

    let error = false;
    const errorObj = { ...errorsObj };

    // if (formData.username === "") {
    //   errorObj.username = "Please enter username";
    //   error = true;
    // }

    if (formData.email === "") {
      errorObj.email = "Please enter email id";
      error = true;
    }

    if (formData.email) {
      if (
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(formData.email)
      ) {
        errorObj.email = "";
        error = false;
      } else {
        errorObj.email = "You have entered an invalid email address!";
        error = true;
      }
    }

    if (formData.mobile === "") {
      errorObj.phone = "Please enter mobile no";
      error = true;
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      // Regex for a 10-digit mobile number
      errorObj.phone = "Please enter a valid 10-digit mobile number";
      error = true;
    }

    if (formData.alternativeNo === "") {
      error = false;
    }
    //  else if (!/^\d{10}$/.test(formData.alternativeNo)) {
    //   // Regex for a 10-digit mobile number
    //   errorObj.alternativeNo = "Please enter a valid 10-digit mobile number";
    //   error = true;
    // }

    if (formData.salutation === "") {
      errorObj.salutation = "Please select salutation";
      error = true;
    }
    if (formData.firstName === "") {
      errorObj.firstName = "Please enter first name";
      error = true;
    }
    if (formData.grade === "") {
      errorObj.grade = "Please enter grade";
      error = true;
    }
    if (formData.board === "") {
      errorObj.board = "Please select board";
      error = true;
    }
    if (formData.state === "") {
      errorObj.state = "Please select state";
      error = true;
    }
    if (formData.language === "") {
      errorObj.language = "Please select language";
      error = true;
    }
    if (formData.tnc === false) {
      errorObj.tnc = "Please accept terms & conditions";
      error = true;
    }

    setErrors(errorObj);
    if (error) return;
    setLoader(true);

    ApiService.postRequest(
      "/users/update",
      {
        username: formData.email.toLowerCase(),
        email: formData.email.toLowerCase(),
        salutation: formData.salutation,
        firstName: formData.firstName,
        middleName: formData.middleName,
        lastName: formData.lastName,
        dob: formData.DOB,
        fatherName: formData.fatherName,
        grade: formData.grade,
        stateId: formData.state,
        category: formData.board,
        school: formData.school,
        address: formData.address,
        city: formData.city,
        mobile: formData.mobile,
        alternativeNo: formData.alternativeNo,
        // roles: ["ROLE_CLIENT"],
        // userLang: formData.language,
      },
      true
    ).then((response) => {
      setLoader(false);
      console.log(response.data.data);

      // if (response?.data?.data) {
      //   setFormData({
      //     username: "",
      //     email: "",
      //     mobile: "",
      //     salutation: "",
      //     firstName: "",
      //     middleName: "",
      //     lastName: "",
      //     board: "",
      //     DOB: "",
      //     grade: "",
      //     school: "",
      //     address: "",
      //     city: "",
      //     fatherName: "",
      //     alternativeNo: "",
      //   });
      //   console.log("Updating user");
      // }
    });
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await ApiService.publicGetRequest(
          "/additional/findallcategory"
        );
        setCategories(response.data.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    const fetchLanguages = async () => {
      try {
        const response = await ApiService.publicGetRequest(
          "/additional/activeLanguageList"
        );
        setLanguages(response.data.data);
      } catch (error) {
        console.error("Error fetching languages:", error);
      }
    };
    const fetchStates = async () => {
      try {
        const response = await ApiService.publicGetRequest(
          "/additional/states"
        );
        setStates(response.data.data);
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };

    fetchCategories();
    fetchLanguages();
    fetchStates();
  }, []);

  useEffect(() => {
    const fetchSubCategories = async (categoryId) => {
      try {
        const response = await ApiService.publicGetRequest(
          `/additional/findsubcategories?categoryId=${categoryId}`
        );
        setSubcategories(response.data.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchSubCategories(formData.board);
  }, [formData.board]);

  return (
    <div className="p-3">
      {/* <div className="d-flex justify-content-end">
        <button
          className="btn btn-primary"
          onClick={() => setEditable(!editable)}
        >
          <FaPencil />
        </button>
      </div> */}
      <form onSubmit={updateUser}>
        <div className="row">
          <div className="col-md-6">
            <label htmlFor="userName" className="form-label fw-bold">
              Username:
            </label>
            <div className="mb-3   position-relative">
              <input
                defaultValue={formData.username}
                type="text"
                className="form-control"
                name="firstName"
                // placeholder="Enter first name*"
                onChange={(ev) => {
                  setFormData({
                    ...formData,
                    username: ev.target.value,
                  });
                }}
                readOnly={true}
                disabled={true}
                // readOnly={!editable}
              />
              {errors.username && (
                <div className="text-danger">{errors.username}</div>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <label htmlFor="salutation" className="form-label fw-bold">
              Salutation:
            </label>
            <div className="mb-3 position-relative">
              <Form.Select
                className="form-control"
                aria-label="Default select example"
                name="salutation"
                value={formData.salutation}
                onChange={(ev) => {
                  setFormData({
                    ...formData,
                    salutation: ev.target.value,
                  });
                }}
                disabled={!editable}
              >
                <option>Select salutation</option>
                <option value="Mr.">Mr</option>
                <option value="Ms.">Ms</option>
                <option value="Miss.">Miss</option>
                <option value="Mrs.">Mrs</option>
              </Form.Select>
            </div>
          </div>

          <div className="col-md-6">
            <label htmlFor="Name" className="form-label fw-bold">
              First name:
            </label>
            <div className="mb-3   position-relative">
              <input
                defaultValue={formData.firstName}
                type="text"
                className="form-control"
                name="firstName"
                placeholder="Enter first name*"
                onChange={(ev) => {
                  setFormData({
                    ...formData,
                    firstName: ev.target.value,
                  });
                }}
                readOnly={!editable}
                disabled={!editable}
              />
              {errors.firstName && (
                <div className="text-danger">{errors.firstName}</div>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <label htmlFor="middleName" className="form-label fw-bold">
              Middle name:
            </label>
            <div className="mb-3   position-relative">
              <input
                defaultValue={formData.middleName}
                type="text"
                className="form-control"
                placeholder="Enter middle name*"
                onChange={(ev) => {
                  setFormData({
                    ...formData,
                    middleName: ev.target.value,
                  });
                }}
                readOnly={!editable}
                disabled={!editable}
              />
              {errors.middleName && (
                <div className="text-danger">{errors.middleName}</div>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <label htmlFor="LastName" className="form-label fw-bold">
              Last name:
            </label>
            <div className="mb-3   position-relative">
              <input
                defaultValue={formData.lastName}
                type="text"
                className="form-control"
                placeholder="Enter last name*"
                onChange={(ev) => {
                  setFormData({
                    ...formData,
                    lastName: ev.target.value,
                  });
                }}
                readOnly={!editable}
                disabled={!editable}
              />
              {errors.lastName && (
                <div className="text-danger">{errors.lastName}</div>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <label htmlFor="fatherName" className="form-label fw-bold">
              Father name:
            </label>
            <div className="mb-3   position-relative">
              <input
                defaultValue={formData.fatherName}
                type="text"
                className="form-control"
                placeholder="Enter father name*"
                onChange={(ev) => {
                  setFormData({
                    ...formData,
                    fatherName: ev.target.value,
                  });
                }}
                readOnly={!editable}
                disabled={!editable}
              />
              {errors.fatherName && (
                <div className="text-danger">{errors.fatherName}</div>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <div className="mb-3 position-relative">
              <label htmlFor="dateOfBirth" className="form-label fw-bold">
                Date of Birth:
              </label>
              <DatePicker
                selected={formData.dateOfBirth}
                onChange={(date) =>
                  setFormData({ ...formData, dateOfBirth: date })
                }
                className="form-control"
                placeholderText="Date of Birth"
                readOnly={!editable}
                disabled={!editable}
              />
            </div>
          </div>

          <div className="col-md-6">
            <label htmlFor="LastName" className="form-label fw-bold">
              School:
            </label>
            <div className="mb-3   position-relative">
              <input
                defaultValue={formData.school}
                type="text"
                className="form-control"
                placeholder="Enter school name*"
                onChange={(ev) => {
                  setFormData({
                    ...formData,
                    school: ev.target.value,
                  });
                }}
                readOnly={!editable}
                disabled={!editable}
              />
              {errors.school && (
                <div className="text-danger">{errors.school}</div>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <label htmlFor="LastName" className="form-label fw-bold">
              Address:
            </label>
            <div className="mb-3   position-relative">
              <input
                defaultValue={formData.address}
                type="text"
                className="form-control"
                placeholder="Enter address"
                onChange={(ev) => {
                  setFormData({
                    ...formData,
                    address: ev.target.value,
                  });
                }}
                readOnly={!editable}
                disabled={!editable}
              />
              {errors.address && (
                <div className="text-danger">{errors.address}</div>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <label htmlFor="City" className="form-label fw-bold">
              City:
            </label>
            <div className="mb-3   position-relative">
              <input
                defaultValue={formData.city}
                type="text"
                className="form-control"
                placeholder="Enter city"
                onChange={(ev) => {
                  setFormData({
                    ...formData,
                    city: ev.target.value,
                  });
                }}
                readOnly={!editable}
                disabled={!editable}
              />
              {errors.city && <div className="text-danger">{errors.city}</div>}
            </div>
          </div>

          <div className="col-md-6">
            <label htmlFor="state" className="form-label fw-bold">
              State:
            </label>
            <div className="mb-3   position-relative">
              <Form.Select
                className="form-control"
                aria-label="Default select example"
                name="selectOption"
                value={formData.state}
                onChange={(ev) => {
                  setFormData({
                    ...formData,
                    state: ev.target.value,
                  });
                }}
                disabled={!editable}
              >
                <option>States</option>
                {states &&
                  states.map((state) => (
                    <option key={state.id} value={state.id}>
                      {state.name}
                    </option>
                  ))}
                {/* <option value="Hindi">Hindi</option>
                                <option value="English">English</option> */}
              </Form.Select>
              {errors.state && (
                <div className="text-danger">{errors.state}</div>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <label htmlFor="Board" className="form-label fw-bold">
              Board:
            </label>
            <div className="mb-3   position-relative">
              <Form.Select
                className="form-control"
                aria-label="Default select example"
                name="selectOption"
                value={formData.board}
                onChange={(ev) => {
                  setFormData({
                    ...formData,
                    board: ev.target.value,
                  });
                }}
                disabled={!editable}
              >
                <option>Select Board * </option>
                {/* <option value="CBSE">CBSE</option>
                                <option value="ICSE">ICSE</option> */}
                {categories &&
                  categories.map((category) => (
                    <option key={category.id} value={category.id}>
                      {category.name}
                    </option>
                  ))}
              </Form.Select>
              {errors.board && (
                <div className="text-danger">{errors.board}</div>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <label htmlFor="Grade" className="form-label fw-bold">
              Grade:
            </label>
            <div className="mb-3   position-relative">
              <Form.Select
                className="form-control"
                aria-label="Default select example"
                name="selectOption"
                value={formData.grade}
                onChange={(ev) => {
                  setFormData({
                    ...formData,
                    grade: ev.target.value,
                  });
                }}
                disabled={!editable || !formData.board} // Disable dropdown if no board is selected
              >
                <option>Select Grade * </option>
                {subcategories &&
                  subcategories.map((subcategory) => (
                    <option key={subcategory.id} value={subcategory.name}>
                      {subcategory.name}
                    </option>
                  ))}
              </Form.Select>
              {errors.grade && (
                <div className="text-danger">{errors.grade}</div>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <label htmlFor="Language" className="form-label fw-bold">
              Language:
            </label>
            <div className="mb-3   position-relative">
              <Form.Select
                className="form-control"
                aria-label="Default select example"
                name="selectOption"
                value={formData.language}
                onChange={(ev) => {
                  setFormData({
                    ...formData,
                    language: ev.target.value,
                  });
                }}
                disabled={!editable}
              >
                <option>Preferred Language</option>
                {languages &&
                  languages.map((language) => (
                    <option key={language.id} value={language.id}>
                      {language.name}
                    </option>
                  ))}
                {/* <option value="Hindi">Hindi</option>
                                <option value="English">English</option> */}
              </Form.Select>
              {errors.language && (
                <div className="text-danger">{errors.language}</div>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <label htmlFor="Mobile" className="form-label fw-bold">
              Mobile:
            </label>
            <div className="mb-3   position-relative">
              <input
                type="number"
                defaultValue={formData.mobile}
                className="form-control"
                placeholder="Mobile No.*"
                onChange={(ev) => {
                  setFormData({
                    ...formData,
                    mobile: ev.target.value,
                  });
                }}
                readOnly={!editable}
                disabled={!editable}
              />
              {errors.phone && (
                <div className="text-danger">{errors.phone}</div>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <label htmlFor="alternateMobile" className="form-label fw-bold">
              Alternative Mobile No.:
            </label>
            <div className="mb-3   position-relative">
              <input
                type="number"
                defaultValue={formData.alternativeNo}
                className="form-control"
                placeholder="Alternative Mobile No."
                onChange={(ev) => {
                  setFormData({
                    ...formData,
                    alternateMobile: ev.target.value,
                  });
                }}
                readOnly={!editable}
                disabled={!editable}
              />
              {errors.alternativeNo && (
                <div className="text-danger">{errors.alternativeNo}</div>
              )}
            </div>
          </div>

          {editable && (
            <div className="form-group mb-3">
              <label htmlFor="photo" className="form-label fw-bold">
                Profile Picture:
              </label>
              <input
                type="file"
                className="form-control"
                id="photo"
                name="photo"
                disabled={!editable}
              />
            </div>
          )}
        </div>
        {editable ? (
          <div className="d-flex justify-content-between align-item-center mt-4">
            {/* <div className="d-grid mt-4"> */}
            {/* <button type="submit" className="btn btn-primary btn-lg">
              Save Profile
            </button> */}
            {/* <button type="submit" className="btn btn-primary btn-lg">
              Save Profile
            </button> */}

            <button
              type="submit"
              className="btn btn-primary2 btn-block"
              disabled={loader}
            >
              {loader && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              Save Profile
            </button>
            <button
              className="btn btn-primary2"
              onClick={() => setEditable(!editable)}
            >
              Cancel
            </button>
          </div>
        ) : (
          // <div className="d-grid mt-4">
          //   <button
          //     className="btn btn-primary2"
          //     onClick={() => setEditable(!editable)}
          //   >
          //     <FaPencil /> Edit details
          //   </button>
          // </div>
          <></>
        )}
      </form>
    </div>
  );
}

export default ProfileEditor;

// import React, { useEffect, useState } from "react";
// import { Form } from "react-bootstrap";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { FaPencil } from "react-icons/fa6";
// import ApiService from "../../services/ApiService";

// function FormField({ label, name, value, onChange, placeholder, readOnly }) {
//   return (
//     <div className="form-group mb-3">
//       <label htmlFor={name} className="form-label fw-bold">
//         {label}
//       </label>
//       <input
//         type="text"
//         className="form-control"
//         id={name}
//         name={name}
//         value={value}
//         onChange={onChange}
//         placeholder={placeholder}
//         readOnly={readOnly}
//       />
//     </div>
//   );
// }

// function ProfileEditor() {
//   const [editable, setEditable] = useState(false);

//   const [loader, setLoader] = useState(false);
//   const [languages, setLanguages] = useState();
//   const [categories, setCategories] = useState([]);
//   const [subcategories, setSubcategories] = useState([]);

//   const [formData, setFormData] = useState({
//     salutation: "",
//     firstName: "",
//     middleName: "",
//     lastName: "",
//     fatherName: "",
//     grade: "",
//     board: "",
//     mobile: "",
//     alternateMobile: "",
//     dateOfBirth: "",
//     school: "",
//     address: "",
//     city: "",
//     twitter: "",
//     facebook: "",
//     linkedin: "",
//   });

//   useEffect(() => {
//     const userDetailss = localStorage.getItem("userDetails");
//     const userData = JSON.parse(userDetailss);

//     setFormData({
//       username: userData.username,
//       email: userData.email,
//       salutation: userData.salutation || "",
//       firstName: userData.firstName || "",
//       middleName: userData.middleName || "",
//       lastName: userData.lastName || "",
//       fatherName: userData.fatherName || "",
//       grade: userData.grade || "",
//       board: userData.category || "",
//       mobile: userData.mobile || "",
//       alternateMobile: userData.alternateMobile || "",
//       dateOfBirth: userData.dob || "",
//       school: userData.school || "",
//       address: userData.address || "",
//       city: userData.city || "",
//       twitter: userData.twitter || "",
//       facebook: userData.facebook || "",
//       linkedin: userData.linkedin || "",
//     });

//     console.log("User details from profile editor", userData);
//   }, []);

//   const handleInputChange = (event) => {
//     setFormData({
//       ...formData,
//       [event.target.name]: event.target.value,
//     });
//   };

//   const updateUser = (e) => {
//     e.preventDefault();
//     ApiService.postRequest(
//       "/users/update",
//       {
//         username: formData.email.toLowerCase(),
//         email: formData.email.toLowerCase(),
//         salutation: formData.salutation,
//         firstName: formData.firstName,
//         middleName: formData.middleName,
//         lastName: formData.lastName,
//         dob: formData.DOB,
//         fatherName: formData.fatherName,
//         grade: formData.grade,
//         category: formData.board,
//         school: formData.school,
//         address: formData.address,
//         city: formData.city,
//         mobile: formData.mobile,
//         alternativeNo: formData.alternativeNo,
//         // roles: ["ROLE_CLIENT"],
//         // userLang: formData.language,
//       },
//       true
//     );
//     console.log("Updating user");
//   };

//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         const response = await ApiService.publicGetRequest(
//           "/additional/findallcategory"
//         );
//         setCategories(response.data.data);
//       } catch (error) {
//         console.error("Error fetching categories:", error);
//       }
//     };
//     const fetchLanguages = async () => {
//       try {
//         const response = await ApiService.publicGetRequest(
//           "/additional/activeLanguageList"
//         );
//         setLanguages(response.data.data);
//       } catch (error) {
//         console.error("Error fetching languages:", error);
//       }
//     };

//     fetchCategories();
//     fetchLanguages();
//   }, []);

//   useEffect(() => {
//     const fetchSubCategories = async (categoryId) => {
//       try {
//         const response = await ApiService.publicGetRequest(
//           `/additional/findsubcategories?categoryId=${categoryId}`
//         );
//         setSubcategories(response.data.data);
//       } catch (error) {
//         console.error("Error fetching categories:", error);
//       }
//     };
//     fetchSubCategories(state.board);
//   }, [formData.board]);

//   return (
//     <div className="p-3">
//       <div className="d-flex justify-content-end">
//         <button
//           className="btn btn-primary"
//           onClick={() => setEditable(!editable)}
//         >
//           <FaPencil />
//         </button>
//       </div>
//       <form onSubmit={updateUser}>
//         <div className="row">
//           <div className="col-md-6">
//             <label htmlFor="salutation" className="form-label fw-bold">
//               Salutation:
//             </label>
//             <div className="mb-3 position-relative">
//               <Form.Select
//                 className="form-control"
//                 aria-label="Default select example"
//                 name="salutation"
//                 value={formData.salutation}
//                 onChange={handleInputChange}
//                 disabled={!editable}
//               >
//                 <option>Select salutation</option>
//                 <option value="Mr.">Mr</option>
//                 <option value="Ms.">Ms</option>
//                 <option value="Miss.">Miss</option>
//                 <option value="Mrs.">Mrs</option>
//               </Form.Select>
//             </div>
//           </div>
//           <div className="col-md-6">
//             <FormField
//               label="First name:"
//               name="firstName"
//               value={formData.firstName}
//               onChange={handleInputChange}
//               placeholder="Enter first name"
//               readOnly={!editable}
//             />
//           </div>
//           <div className="col-md-6">
//             <FormField
//               label="Middle name:"
//               name="middleName"
//               value={formData.middleName}
//               onChange={handleInputChange}
//               placeholder="Enter middle name"
//               readOnly={!editable}
//             />
//           </div>
//           <div className="col-md-6">
//             <FormField
//               label="Last name:"
//               name="lastName"
//               value={formData.lastName}
//               onChange={handleInputChange}
//               placeholder="Enter last name"
//               readOnly={!editable}
//             />
//           </div>
//           <div className="col-md-6">
//             <FormField
//               label="Father name:"
//               name="fatherName"
//               value={formData.fatherName}
//               onChange={handleInputChange}
//               placeholder="Enter father's name"
//               readOnly={!editable}
//             />
//           </div>
//           <div className="col-md-6">
//             <FormField
//               label="Grade:"
//               name="grade"
//               value={formData.grade}
//               onChange={handleInputChange}
//               placeholder="Enter grade"
//               readOnly={!editable}
//             />
//           </div>
//           <div className="col-md-6">
//             <FormField
//               label="Board:"
//               name="board"
//               value={formData.board}
//               onChange={handleInputChange}
//               placeholder="Enter board"
//               readOnly={!editable}
//             />
//           </div>
//           <div className="col-md-6">
//             <FormField
//               label="Mobile:"
//               name="mobile"
//               value={formData.mobile}
//               onChange={handleInputChange}
//               placeholder="Enter mobile number"
//               readOnly={!editable}
//             />
//           </div>
//           <div className="col-md-6">
//             <FormField
//               label="Alternate mobile:"
//               name="alternateMobile"
//               value={formData.alternateMobile}
//               onChange={handleInputChange}
//               placeholder="Enter alternate mobile number"
//               readOnly={!editable}
//             />
//           </div>
//           <div className="col-md-6">
//             <div className="mb-3 position-relative">
//               <label htmlFor="dateOfBirth" className="form-label fw-bold">
//                 Date of Birth:
//               </label>
//               <DatePicker
//                 selected={formData.dateOfBirth}
//                 onChange={(date) =>
//                   setFormData({ ...formData, dateOfBirth: date })
//                 }
//                 className="form-control"
//                 placeholderText="Date of Birth"
//                 readOnly={!editable}
//               />
//             </div>
//           </div>
//           <div className="col-md-6">
//             <FormField
//               label="School:"
//               name="school"
//               value={formData.school}
//               onChange={handleInputChange}
//               placeholder="Enter school"
//               readOnly={!editable}
//             />
//           </div>
//           <div className="col-md-6">
//             <FormField
//               label="Address:"
//               name="address"
//               value={formData.address}
//               onChange={handleInputChange}
//               placeholder="Enter address"
//               readOnly={!editable}
//             />
//           </div>
//           <div className="col-md-6">
//             <FormField
//               label="City:"
//               name="city"
//               value={formData.city}
//               onChange={handleInputChange}
//               placeholder="Enter city"
//               readOnly={!editable}
//             />
//           </div>
//           <div className="col-md-6">
//             <FormField
//               label="Twitter:"
//               name="twitter"
//               value={formData.twitter}
//               onChange={handleInputChange}
//               placeholder="http://twitter.com"
//               readOnly={!editable}
//             />
//           </div>
//           <div className="col-md-6">
//             <FormField
//               label="Facebook:"
//               name="facebook"
//               value={formData.facebook}
//               onChange={handleInputChange}
//               placeholder="http://www.facebook.com"
//               readOnly={!editable}
//             />
//           </div>
//           <div className="col-md-6">
//             <FormField
//               label="LinkedIn:"
//               name="linkedin"
//               value={formData.linkedin}
//               onChange={handleInputChange}
//               placeholder="http://www.linkedin.com"
//               readOnly={!editable}
//             />
//           </div>
//           {editable && (
//             <div className="form-group mb-3">
//               <label htmlFor="photo" className="form-label fw-bold">
//                 Profile Picture:
//               </label>
//               <input
//                 type="file"
//                 className="form-control"
//                 id="photo"
//                 name="photo"
//                 disabled={!editable}
//               />
//             </div>
//           )}
//         </div>
//         {editable && (
//           <div className="d-grid mt-4">
//             <button type="submit" className="btn btn-primary btn-lg">
//               Save Profile
//             </button>
//           </div>
//         )}
//       </form>
//     </div>
//   );
// }

// export default ProfileEditor;
